import { cn } from "@/lib/utils";
import { Field } from "@base-ui/react/field";
import { TextareaHTMLAttributes, useId } from "react";
import Label from "../label";
import Description from "../description";
import FieldError from "../field-error";

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "placeholder"> {
	label?: string;
	hideLabel?: boolean;
	description?: string | null;
	error?: string;
	placeholder?: string | number | null;
	containerClassName?: string;
}

const Textarea: React.FC<TextareaProps> = ({ label, hideLabel, description, error, placeholder, containerClassName, ...props }) => {
	const generatedId = useId();
	const id = props.id ?? generatedId;
	const { maxLength, ...textareaProps } = props;

	return (
		<Field.Root className={cn("flex flex-col items-start gap-2", containerClassName)}>
			{label && (
				<Label htmlFor={id} required={props.required} visible={!hideLabel}>
					{label}
				</Label>
			)}

			<textarea
				{...textareaProps}
				id={id}
				placeholder={placeholder?.toString() ?? undefined}
				className="ms-input w-full text-base focus:outline-2 focus:-outline-offset-1"
			/>

			{description && <Description>{description}</Description>}

			<FieldError
				message={error}
				values={{
					min: typeof props.minLength === "number" ? props.minLength : 0,
					max: typeof maxLength === "number" ? maxLength : 0,
				}}
			/>
		</Field.Root>
	);
};

export default Textarea;
